import { render, staticRenderFns } from "./MobileDetail.vue?vue&type=template&id=6338945e&scoped=true"
import script from "./MobileDetail.vue?vue&type=script&lang=js"
export * from "./MobileDetail.vue?vue&type=script&lang=js"
import style0 from "./MobileDetail.vue?vue&type=style&index=0&id=6338945e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6338945e",
  null
  
)

export default component.exports